import React from 'react'
import { makeStyles, Icon } from '@material-ui/core'
import { errors } from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

/**
 * Prominent warning for when a client has no card on file at the facility a visit is
 * happening at. Facilities can run on separate Stripe instances, so a card saved at
 * another location cannot be charged for this visit.
 */
const NoFacilityCardWarning = ({ facilityName, hasPaymentMethod, loading, style = {} }) => {
	const classes = useStyles()

	// `null` means we could not determine it — don't raise a false alarm.
	if (loading || hasPaymentMethod !== false) return null

	return (
		<div className={classes.root} style={style}>
			<Icon className={`fa fa-exclamation-triangle ${classes.icon}`} />
			<div>
				<div className={classes.title}>No payment method on file for this location</div>
				<div className={classes.body}>
					{facilityName
						? `This client has no card saved at ${facilityName}. Cards are stored separately per location, so a card at another location cannot be charged for this visit.`
						: 'This client has no card saved at the location for this visit. Cards are stored separately per location, so a card at another location cannot be charged for this visit.'}{' '}
					Add a payment method for this location before the visit is completed.
				</div>
			</div>
		</div>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		backgroundColor: errors[10],
		border: `2px solid ${errors[500]}`,
		borderRadius: '.5rem',
		padding: '1rem 1.25rem',
		display: 'flex',
		gap: '1rem',
		alignItems: 'flex-start',
		width: '100%'
	},
	icon: {
		color: errors[500],
		fontSize: '1.5rem',
		overflow: 'unset'
	},
	title: {
		fontFamily: 'Nunito',
		fontSize: '1.125rem',
		fontWeight: FONT_WEIGHTS.Bold,
		color: errors[500],
		marginBottom: '.25rem'
	},
	body: {
		fontFamily: 'Nunito',
		fontSize: '0.9375rem',
		fontWeight: FONT_WEIGHTS.Regular,
		color: 'black'
	}
}))

export default NoFacilityCardWarning
